import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BranchService, LocationService } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { SubSink } from 'subsink2';
import { Observable } from 'rxjs';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-util-generic-document-view-main',
  templateUrl: './generic-document-view-main.component.html',
  styleUrls: ['./generic-document-view-main.component.css']
})

export class GenericDocumentViewMainComponent implements OnInit, OnDestroy {
  @Input() genericDoc$: Observable<any>;
  apiVisa = AppConfig.apiVisa;
  private subs = new SubSink();

  form: FormGroup;
  leftColControls = [
    {label: 'Branch', formControl: 'branch', type: 'text', readonly: true},
    {label: 'Reference', formControl: 'reference', type: 'text', readonly: true},
    {label: 'Credit Terms', formControl: 'creditTerms', type: 'text', readonly: true},
    {label: 'Sales Agent', formControl: 'salesAgent', type: 'text', readonly: true},
  ];

  rightColControls = [
    {label: 'Location', formControl: 'location', type: 'text', readonly: true},
    {label: 'Transaction Date', formControl: 'transactionDate', type: 'text', readonly: true},
    {label: 'Currency', formControl: 'currency', type: 'text', readonly: true},

  ];

  constructor(
    private locationService: LocationService,
    private branchService: BranchService) {
  }

  ngOnInit() {
    this.form = new FormGroup({
      branch: new FormControl(),
      location: new FormControl(),
      reference: new FormControl(),
      creditTerms: new FormControl(),
      transactionDate: new FormControl(),
      salesAgent: new FormControl(),
      currency: new FormControl(),
      remarks: new FormControl(),
    });

    this.subs.sink = this.genericDoc$.subscribe(resolve => {
      this.form.patchValue({
        reference: resolve.bl_fi_generic_doc_hdr.doc_reference,
        creditTerms: (<any>resolve).bl_fi_generic_doc_hdr?.doc_entity_hdr_json?.creditTerms,
        transactionDate: SharedUtilitiesHelperFunctions.dateFormatter(resolve.bl_fi_generic_doc_hdr.date_txn),
        salesAgent: (<any>resolve).bl_fi_generic_doc_hdr.sales_entity_hdr_name,
        currency: resolve.bl_fi_generic_doc_hdr.doc_ccy,
        remarks: resolve.bl_fi_generic_doc_hdr.doc_remarks
      });
      this.branchService.getByGuid(resolve.bl_fi_generic_doc_hdr.guid_branch.toString(),this.apiVisa).subscribe((resp) => {
        this.form.patchValue({
          branch : resp.data.bl_fi_mst_branch.name,
        });
      });
      this.locationService.getByGuid(resolve.bl_fi_generic_doc_hdr.guid_store.toString(),this.apiVisa).subscribe((resp) => {
        this.form.patchValue({
          location : resp.data.bl_inv_mst_location.name,
        });
      });
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
